import React from 'react';
import styled, { keyframes } from 'styled-components';
import { EmptyState } from './slideStyles';

interface SlideLoadingProps {
  message?: string;
  Wrapper?: React.ComponentType<any>;
}

const LoadingOverlay = styled.div`
  position: absolute;
  inset: 0;
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  background: rgba(255, 255, 255, 0.96);
  border-radius: 1rem;
`;

const SpinnerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  padding: 1.25rem 1.75rem;
  border-radius: 1rem;
  background: rgba(255, 255, 255, 0.95);
  box-shadow: 0 16px 40px rgba(15, 23, 42, 0.12);
`;

const spin = keyframes`
  to { transform: rotate(360deg); }
`;

const SpinnerRing = styled.div`
  width: 56px;
  height: 56px;
  border: 5px solid rgba(15, 23, 42, 0.15);
  border-top-color: #2563eb;
  border-radius: 50%;
  animation: ${spin} 0.75s linear infinite;
`;

const SpinnerText = styled.div`
  font-family: 'Poppins', sans-serif;
  font-size: 15px;
  color: #334155;
  text-align: center;
  font-weight: 600;
`;

const SlideLoading: React.FC<SlideLoadingProps> = ({
  message = 'Loading...',
  Wrapper = EmptyState as React.ComponentType<any>,
}) => (
  <LoadingOverlay>
    <Wrapper>
      <SpinnerWrapper>
        <SpinnerRing aria-hidden="true" />
        <SpinnerText>{message}</SpinnerText>
      </SpinnerWrapper>
    </Wrapper>
  </LoadingOverlay>
);

export default SlideLoading;
